module.exports = __webpack_public_path__ + "img/RefusedE.53929532.png";